export default __webpack_public_path__ + "static/media/img2.30a5208a.png";